module.exports = __webpack_public_path__ + "img/Führungstrupp.7915ccfe.svg";